/* eslint-disable no-unused-vars */
import { returnErrors } from './errorAction';
import { getApiCall, postApiCall } from '../utils/request';
import { GET_ALERTS, UPDATE_ALERTS, GET_POPUP_NOTIFICATION, TRACK_USER, USER_LOGOUT, ALL_LOGOUT, GET_SEARCH_SUGGESTIONS, GET_NEXT_SEARCH_SUGGESTIONS } from '../actionType/type';


export const getAlerts = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/profile/alert`);
        dispatch({ type: GET_ALERTS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const updateAlert = (key) => async (dispatch) => {
    let keys = { key }
    try {
        const response = await postApiCall(`user/profile/alert`, keys);
        dispatch({ type: UPDATE_ALERTS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNotifications = () => async (dispatch) => {

    try {
        const response = await getApiCall(`notification?page=1&unread=true`);
        if (response.data.unread === 0) {
            const response2 = await getApiCall(`notification?page=1&unread=false`);
            if (response2.data.success) {
                dispatch({ type: GET_POPUP_NOTIFICATION, payload: response2.data });
            }
        }
        else {
            if (response.data.success) {
                dispatch({ type: GET_POPUP_NOTIFICATION, payload: response.data });
            }
        }
    } catch (error) {
        returnErrors(dispatch, error.response !== undefined && error.response.data.message, error.response !== undefined && error.response.status);
    }
}



export const logOutUser = () => async (dispatch) => {
    try {
        const response = await postApiCall(`auth/logout`);
        dispatch({ type: USER_LOGOUT });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}


export const logOutFromDevices = () => async (dispatch) => {
    try {
        const response = await postApiCall(`auth/logout-all`);
        dispatch({ type: ALL_LOGOUT });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const trackUserLogin = () => async (dispatch) => {
    try {
        const response = await postApiCall(`track/userlogin`);
        dispatch({ type: TRACK_USER });

    } catch (error) {
        returnErrors(dispatch, error.response !== undefined && error.response.data.message, error.response !== undefined && error.response.status);
    }
}

export const getSearchSuggestion = (query, page) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/search?query=${encodeURIComponent(query)}&page=${page}`);
        dispatch({ type: GET_SEARCH_SUGGESTIONS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextSuggestion = (query, page) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/search?query=${encodeURIComponent(query)}&page=${page}`);
        dispatch({ type: GET_NEXT_SEARCH_SUGGESTIONS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

